module.exports = __webpack_public_path__ + "img/wix.15a7fdda.svg";